const APIEndpoint = {
  GPTTurbo: "https://api.openai.com/v1/chat/completions",
};
export default APIEndpoint;
